import React, { Component } from 'react'
import Modal from './Modal'
class BigModal extends Component {
  render () {
    return <Modal {...this.props} big />
  }
}
export default BigModal



// WEBPACK FOOTER //
// ./src/components/basic/containers/BigModal.js